/* ==========================================================================
   VFLUO — Barre de livraison offerte dynamique
   Met à jour la/les barre(s) [data-vfluo-fsb] sur les events natifs Impulse :
     - cart:updated      (changement de quantité dans panier / drawer)
     - ajaxProduct:added (ajout au panier depuis une fiche produit)
   Le rendu initial est fait côté Liquid (snippets/free-shipping-bar.liquid).
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    // Fallback EUR si theme.Currency indisponible
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateBars(totalCents) {
    if (typeof totalCents !== 'number' || isNaN(totalCents)) return;

    var bars = document.querySelectorAll('[data-vfluo-fsb]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold || threshold <= 0) return;

      var msgEl = bar.querySelector('[data-vfluo-fsb-message]');
      var fillEl = bar.querySelector('[data-vfluo-fsb-fill]');
      var remaining = threshold - totalCents;

      // Panier vide → masquer
      if (totalCents <= 0) {
        bar.classList.add('vfluo-fsb--hidden');
        return;
      }
      bar.classList.remove('vfluo-fsb--hidden');

      if (remaining <= 0) {
        // Seuil atteint
        bar.classList.add('vfluo-fsb--success');
        if (msgEl) msgEl.textContent = bar.getAttribute('data-text-success') || '';
        if (fillEl) fillEl.style.width = '100%';
      } else {
        // En progression
        bar.classList.remove('vfluo-fsb--success');
        var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
        if (fillEl) fillEl.style.width = pct + '%';
        if (msgEl) {
          var tmpl = bar.getAttribute('data-text-progress') || '';
          msgEl.textContent = tmpl.replace('[amount]', formatMoney(remaining));
        }
      }
    });
  }

  // Changement de quantité (panier + drawer) : le détail contient le cart complet
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart && typeof evt.detail.cart.total_price === 'number') {
      updateBars(evt.detail.cart.total_price);
    }
  });

  // Ajout depuis une fiche produit : pas de cart dans l'event → on récupère /cart.js
  document.addEventListener('ajaxProduct:added', function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBars(cart.total_price); })
      .catch(function () {});
  });
})();
